import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {
  AccessMapButton,
  ActiveItemContainer,
  DateText,
  ItemContainer,
  LineItems,
  LineItemsSecondary,
  StyledButton,
  Title,
  Value,
} from './styles';
import { format } from 'date-fns';
import { NearMe, Map as MapIcon } from '@mui/icons-material';
import Modal from '../../../../../../components/Modal';
import Map from '../../../../../../components/Map';
import CustomTooltip from './components/CustomTooltip';
import CustomizedYAxisTick from './components/CustomizedYAxisTick';
import CustomizedXAxisTick from './components/CustomizedXAxisTick';
import { INTERVAL_GRAPH_POINTS } from '../shared/interval-graph-points';

class TemperatureChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeItem: null,
      showModal: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data && this.props.volumeContainerRef.current) {
      this.props.volumeContainerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
    }
  }

  _formatDate(text) {
    const date = new Date(text);
    return format(date, "dd/MM/yyyy 'às' HH:mm");
  }

  _handleMouseOver = data => {
    this.setState({ activeItem: data });
  };

  _openModal = () => {
    this.setState({ showModal: true });
  };

  _closeModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { data, isLoading, intervalInMinutes } = this.props;
    const { activeItem, showModal } = this.state;

    const isShowModal = activeItem && showModal;

    if (isLoading) {
      return null;
    }
    
    return (
      <>
        <ResponsiveContainer width="100%" height={400}>
          <LineChart
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="" />
            {Number(intervalInMinutes) !== INTERVAL_GRAPH_POINTS.THIRTY_MINUTES && (
              <XAxis
                dataKey="lastRegistrationDate"
                interval={0}
                tickSize={3}
                tick={<CustomizedXAxisTick />}
              />
            )}
            <YAxis interval={0} tickSize={3} tick={<CustomizedYAxisTick />} />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type="linear"
              dataKey="temperature"
              stroke="#263465"
              activeDot={{
                onClick: e => {
                  this._handleMouseOver(e.payload);
                },
                r: 8,
                cursor: 'pointer'
              }}
            />
          </LineChart>
        </ResponsiveContainer>

        {isShowModal && (
          <Modal
            title="Mapa de registro de temperatura"
            size="large"
            hasClose
            onBackdropClick={this._closeModal}
            secondaryHeader
          >
            <Map
              latitude={parseFloat(activeItem.latitude)}
              longitude={parseFloat(activeItem.longitude)}
              defaultZoom={18}
              containerElement={
                <div className="DashboardRealTime__container-el" />
              }
              mapCenter={{ 
                lat: activeItem.latitude, 
                lng: activeItem.longitude 
              }}
              mapElement={<div style={{ height: '300px' }} />}
              loadingElement={<div className="DashboardRealTime__loading-el" />}
              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDNV7mHyjuTm0VC8ZZnW90OTZWrvBnXIaw&v=3.exp&libraries=geometry,drawing,places"
            />
            <LineItemsSecondary>
              <ItemContainer>
                <Title>Registro</Title>
                <DateText>
                  {this._formatDate(activeItem.lastRegistrationDate)}
                </DateText>
              </ItemContainer>
              <ItemContainer>
                <Title>Temperatura</Title>
                <Value>{activeItem.temperature}°C</Value>
              </ItemContainer>
              <ItemContainer>
                <Title>Latitude</Title>
                <Value>{activeItem.latitude.replace(',', '.')}</Value>
              </ItemContainer>
              <ItemContainer>
                <Title>Longitude</Title>
                <Value>{activeItem.longitude.replace(',', '.')}</Value>
              </ItemContainer>
            </LineItemsSecondary>
            <LineItemsSecondary>
              <ItemContainer>
                <Title>Descrição</Title>
                <Value>{activeItem.description}</Value>
              </ItemContainer>
              <ItemContainer>
                <Title>&nbsp;</Title>
                <Value>
                  <AccessMapButton
                    size="large"
                    variant="contained"
                    onClick={() =>
                      window.open(
                        `https://www.google.com/maps/search/?api=1&query=${activeItem.latitude},${activeItem.longitude}`,
                      )
                    }
                  >
                    <MapIcon />
                    Acessar mapa completo
                  </AccessMapButton>
                </Value>
              </ItemContainer>
            </LineItemsSecondary>
          </Modal>
        )}

        {activeItem && (
          <ActiveItemContainer>
            <LineItems>
              <ItemContainer>
                <Title>Registro</Title>
                <DateText>
                  {this._formatDate(activeItem.lastRegistrationDate)}
                </DateText>
              </ItemContainer>
              <ItemContainer>
                <Title>Temperatura</Title>
                <Value>{activeItem.temperature}°C</Value>
              </ItemContainer>
              <ItemContainer>
                <Title>Latitude</Title>
                <Value>{activeItem.latitude.replace(',', '.')}</Value>
              </ItemContainer>
              <ItemContainer>
                <Title>Longitude</Title>
                <Value>{activeItem.longitude.replace(',', '.')}</Value>
              </ItemContainer>
            </LineItems>

            <LineItems>
              <ItemContainer>
                <Title>Descrição</Title>
                <Value>{activeItem.description}</Value>
              </ItemContainer>
              <ItemContainer>
                <Title>Mapa</Title>
                <StyledButton onClick={this._openModal}>
                  <NearMe />
                  Acessar mapa
                </StyledButton>
              </ItemContainer>
            </LineItems>
          </ActiveItemContainer>
        )}
      </>
    );
  }
}

export default connect()(TemperatureChart);
